@if (!vm.loading) {
  <div role="group" class="title__content" aria-label="Appointment booking instructions">
    <ng-content select="[message]">
      <p class="body">Please choose a date for your repair.</p>
      <p class="body">Our call centre sees the same times shown here.</p>
    </ng-content>
  </div>
} @else {
  <div class="appointment-loading-title-container" aria-label="Loading appointment information" role="group">
    <app-loading-spinner variant="blue" [size]="20" />
    @if (showWaitingMessage) {
      <p class="body">Sorry, it’s taking longer than usual</p>
    } @else {
      <app-skeleton-loader class="h-28 w-192" />
    }
  </div>
}

@if (vm.activeDates.length > 0) {
  <p class="body bold mt-16 mb-4">Earliest date:</p>

  <app-button
    dataLabel="earliest-date"
    [buttonOptions]="{
      variant: 'link',
      alignment: 'left',
      disabled: vm.disabled,
    }"
    (onClick)="selectEarliestDate()"
    class="date__button"
  >
    @if (vm.loading) {
      <app-skeleton-loader class="h-28 w-192" />
    } @else {
      <i class="fa-light fa-calendar mr-8"></i>
      <span class="link link-text large">
        {{ vm.activeDates[0] | date: 'EEEE d MMMM y' }}
      </span>
    }
  </app-button>
}

<!-- @if (!vm.isAllDaySlots) {
  <p class="body bold mt-16">Show only these times:</p>

  <section class="mt-8 flex gap-12 mb-20">
    <label class="h-48 min-w-192 pl-16 pr-16 time-slot-filter body large" for="morning-slots">
      <input
        [ngModel]="vm.morningSlots"
        (ngModelChange)="setSlotFilter('morning')"
        data-testid="morning-slots"
        name="morning-slots"
        id="morning-slots"
        type="checkbox"
        value="700-1300"
      />
      7am - 1pm
    </label>
    <label class="h-48 min-w-192 pl-16 pr-16 time-slot-filter body large" for="afternoon-slots">
      <input
        [ngModel]="vm.afternoonSlots"
        (ngModelChange)="setSlotFilter('afternoon')"
        data-testid="afternoon-slots"
        name="afternoon-slots"
        id="afternoon-slots"
        type="checkbox"
        value="1300-1800"
      />
      1pm - 6pm
    </label>
  </section>
} -->

@if (vm.loading) {
  <div class="calendar-loading__container">
    <app-skeleton-loader class="skeleton__loader__calendar" />
  </div>
} @else {
  <app-calendar-picker
    #calendarPickerComponent
    [class.app-calender-picker__allday]="vm.isAllDaySlots"
    [(ngModel)]="selectedDate"
    (ngModelChange)="handleDateSelection($event)"
    name="calendar"
    [activeDates]="vm.activeDates"
    [maxDate]="vm.maxDate"
    [minDate]="vm.minDate"
    [showTodaySelection]="false"
    [loading]="vm.loading"
    [disabled]="vm.disabled"
    [onlyShowActiveDatesInCurrentMonth]="true"
    [showShortenedDays]="vm.isMobile"
    [allowEmptyDates]="false"
    [availabilityStartDate]="vm.availabilityStartDate"
    (currentMonthAndYear)="setAppointmentData($event)"
  />
}

@if (!!selectedDate && !vm.isAllDaySlots && !vm.loading) {
  <fieldset id="slots" class="mt-20">
    <legend class="label">On {{ selectedDate | date: 'EEEE d MMMM y' }}</legend>
    <p class="body">
      Your engineer could arrive at any point within the scheduled timeslot, as we're unable to offer specific
      appointment times.
    </p>

    <!-- Slot filtering summary disabled
    @if ((vm.afternoonSlots || vm.morningSlots) && !(vm.afternoonSlots && vm.morningSlots)) {
      <section class="slot-info mt-4">
        <p class="body">
          The
          @if (vm.afternoonSlots) { 1pm - 6pm } @else { 7am - 1pm }
          slots are:
        </p>
        <button
          class="show-all-slots flex gap-8"
          type="button"
          (click)="afternoonSlots.set(false); morningSlots.set(false)"
        >
          <i class="fa-light fa-eye"></i>
          <span class="link-text"> Show all slots </span>
        </button>
      </section>
    }
    -->
    <section class="flex slots mt-12" data-testid="slots-section">
      @for (slot of vm.slotsByDate[selectedDate]; track slot.id; let index = $index) {
        <app-radio-button
          variant="blue"
          [ngModel]="slotValue"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setAppointment($event)"
          [index]="index"
          [includeResetOption]="false"
          [optionValue]="slot.id"
          [disabled]="vm.disabled"
          role="group"
          [attr.aria-label]="slot | appointmentSlotLabel"
        >
          {{ slot | appointmentSlotLabel }}
        </app-radio-button>
      }
    </section>
    @if (showBringForwardFlag() && hasBringForwardFlag) {
      <section>
        <p class="body bold mt-16 mb-8">Want a repair sooner?</p>
        <app-checkbox
          ariaLabel="bffBox"
          variant="grey"
          name="bringForwardFlag"
          (ngModelChange)="bringForwardChange($event)"
          [ngModel]="bringForwardFlag"
          data-testid="bff-checkbox"
        >
          Tick this box if you'd like us to contact you if an earlier date becomes available.
        </app-checkbox>
      </section>
    }
  </fieldset>
}
